import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../programsdash/ProgramsDash.css";
import Menu from "../../components/menu/Menu";
import CompanyMembersList from "../../components/companymembers/CompanyMembersList";
import MyProfile from "../../components/profile/MyProfile";
// import AddPtForm from "../../components/addptform/AddPtForm";
import "../companyclients/Clients.css";
import "./SettingsDash.css";
import CompanyTherapistsList from "../../components/companytherapistslist/CompanyTherapistsList";
// import { Link } from "react-router-dom";
// import Rewards from "../../components/rewards/Rewards";
import AdminTab from "../../components/admintab/AdminTab";
import { Context } from "../../context/Context";

const SettingsDash = (props) => {
  const { innerWidth, membersData, setMembersData, therapistTabData, setTherapistTabData, contentLoaded, setContentLoaded } = useContext(Context);
  const [selectedTab, setSelectedTab] = useState("Profile");
  // const [membersData, setMembersData] = useState([]);
  // const [therapistTabData, setTherapistTabData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [contentLoaded, setContentLoaded] = useState(false);
  const [contentLoadedTherapist, setContentLoadedTherapist] = useState(false);
  const [search, setSearch] = useState("");
  const searchMembers = useRef("");
  const searchTherapists = useRef("");
  const [isSorted, setSorted] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);
  const [adminName, setAdminName] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [memberDeleteId, setMemberDeleteId] = useState(0);
  const navigate = useNavigate();
  const [succPopUp, setSuccPopUp] = useState(false);
  const [membDel, setMembDel] = useState(false);
  const [membCopy, setMembCopy] = useState(false);
  const [invTherapistId, setInvTherapistId] = useState(0);
  const [isEmailSent, setEmailSent] = useState(false);
  const [hasCompanyTherapists, setHasCompanyTherapists] = useState(false);
  const [isTherapistCreated, setTherapistCreated] = useState(false);

  useEffect(() => {
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
  }, [])
  
  const popupRef = useRef(succPopUp);
  useEffect(() => {
    popupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp(false);
      setMembDel(false);
      setMembCopy(false);
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  const isSuperAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).super_admin === 1
        ? true
        : false
      : false;

  const isCompanyAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).company_admin === 1
        ? true
        : false
      : false;

  const isPTCompany =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).business_id > 0
        ? true
        : false
      : false;

  const hasCompany =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).company_id > 0
        ? true
        : false
      : false;

  //Sending Through props to reward component
  // const companyId = JSON.parse(localStorage.getItem("userData")).company_id;

  const previosLink =
    localStorage.getItem("prev_link") &&
    JSON.parse(localStorage.getItem("prev_link"))
      ? JSON.parse(localStorage.getItem("prev_link"))
      : false;

  useEffect(() => {
    props.actSidebar(true);
    const currentUserData = JSON.parse(localStorage.getItem("userData"));
    if (currentUserData === null) {
      props.checkLoggedIn(false);
    } else {
      setLoading(true);
      if (
        selectedTab === "Therapists" ||
        selectedTab === "Members" ||
        // selectedTab === "Rewards" ||
        selectedTab === "Admin"
      ) {
        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("userData")
        ).token;
        axios
          .post(window.ajaxLink + "cloud_therapist/therapistSettingsData", {
            search,
            selectedTab,
          })
          .then((res) => {
            if (res.data.responseData) {
              setLoading(false);
              setMembersData(res.data.responseData);

              let lastMember = res.data.responseData.reduce(
                (latest, current) => {
                  return current.memberId > latest.memberId ? current : latest;
                },
                res.data.responseData[0]
              );

              if (lastMember) {
                localStorage.setItem("lastPatCode", lastMember.patient_code);
              }

              setContentLoaded(true);
              if (JSON.parse(localStorage.getItem("newMemberAdded")) !== null) {
                setSuccPopUp(true);
                localStorage.removeItem("newMemberAdded");
              }
            }
          })
          .catch((error) => {
            console.error(error);
            if (
              error.response.data.responseCode === 400 ||
              error.response.data.responseCode === 401
            ) {
              props.checkLoggedIn(false);
            }
            setLoading(false);
            setContentLoaded(true);
          });

        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("userData")
        ).token;
        if (isPTCompany || isSuperAdmin) {
          axios
            .post(window.ajaxLink + "cloud_therapist/companyTherapistsList", {
              search,
              selectedTab,
            })
            .then((res) => {
              if (res.data.responseData) {
                setLoading(false);
                setTherapistTabData(res.data.responseData);
                setContentLoadedTherapist(true);

                for (var oneTher of res.data.responseData) {
                  if (
                    hasCompanyTherapists === false &&
                    res.data.responseData.length > 0 &&
                    oneTher.isRegistered === 1
                  ) {
                    setHasCompanyTherapists(true);
                  }
                }

                if (
                  JSON.parse(localStorage.getItem("AddedNewTherapist")) !== null
                ) {
                  setTherapistCreated(true);
                  setSuccPopUp("Therapist has been created.");
                  localStorage.removeItem("AddedNewTherapist");
                }
              }
            })
            .catch((error) => {
              console.error(error);
              if (
                error.response.data.responseCode === 400 ||
                error.response.data.responseCode === 401
              ) {
                props.checkLoggedIn(false);
              }
              setLoading(false);
              setContentLoaded(true);
            });
        }
      }
    }
    // eslint-disable-next-line
  }, [search, selectedTab]);

  useEffect(() => {
    setIsNewUser(
      localStorage.getItem("userData") &&
        JSON.parse(localStorage.getItem("userData"))
        ? JSON.parse(localStorage.getItem("userData")).is_new_user === 1
          ? true
          : false
        : false
    );
    setAdminName(
      localStorage.getItem("userData") &&
        JSON.parse(localStorage.getItem("userData"))
        ? JSON.parse(localStorage.getItem("userData")).first_name
        : "[fName]"
    );
    if (isCompanyAdmin || isSuperAdmin) {
      setSelectedTab("Members");
    }
    // eslint-disable-next-line
  }, []);

  const updateSearchQuery = (value) => {
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "") {
      setSearch("");
    }
  };

  const handleSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setMembersData(sorted);
  };

  const handleTherapistSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setTherapistTabData(sorted);
  };

  const handleSelectedTab = (tab) => {
    setErrorPopUp("");
    setSuccPopUp(false);
    setSelectedTab(tab);
    setContentLoaded(false);
    setSearch("");
    localStorage.setItem("prev_link", JSON.stringify(tab));
  };

  useEffect(() => {
    if (previosLink) {
      setSelectedTab(previosLink);
    }
  }, [previosLink]);

  const handleModalDots = (i) => {
    const data = [...membersData];
    for (let m of data) {
      m.modalOpened = false;
    }
    let toggle = data[i].modalOpened;
    data[i].modalOpened = !toggle;
    setMembersData(data);
  };
  const popupSuccRef = useRef(succPopUp);
  useEffect(() => {
    popupSuccRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);
  const handleTherapistModal = (i) => {
    const data = [...therapistTabData];
    for (let m of data) {
      m.modalOpened = false;
    }
    let toggle = data[i].modalOpened;
    data[i].modalOpened = !toggle;
    setTherapistTabData(data);
  };

  const handleDeleteModal = (id) => {
    setModalVisible(true);
    const data = [...membersData];
    for (let m of data) {
      m.modalOpened = false;
    }
    setMembersData(data);
    setMemberDeleteId(id);
  };

  const handleResendInvitation = () => {
    setLoading(true);
    setErrorPopUp("");
    const data = therapistTabData.find(
      (item) => item.memberId === invTherapistId
    );
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/resendInvitationTherapistMail", {
        data,
      })
      .then((res) => {
        if (res.data.responseData) {
          setLoading(false);
          setContentLoaded(true);
          closeResendModal();
          setEmailSent(true);
          setSuccPopUp("Invitation email has been sent.");
        }
      })
      .catch((error) => {
        console.error(error);
        if (
          error.response.data.responseCode === 400 ||
          error.response.data.responseCode === 401
        ) {
          setErrorPopUp(error.response.data.errorData);
          setSuccPopUp(false);
          setLoading(false);
          setContentLoaded(true);
          closeResendModal();
        }
      });
  };

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRefErr = useRef(errorPopUp);
  useEffect(() => {
    popupRefErr.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const handleResendModal = (id) => {
    setInvTherapistId(id);
    setModalVisible(true);
  };

  const closeDeleteModal = () => {
    setModalVisible(false);
  };

  const closeResendModal = () => {
    setModalVisible(false);
    setInvTherapistId(0);
  };
  const closeDotModal = () => {
    const data = [...membersData];
    for (let m of data) {
      m.modalOpened = false;
    }
    setMembersData(data);
  };

  const updateMemberData = (data) => {
    setMembersData(data);
  };

  const updateTherapistData = (data) => {
    setTherapistTabData(data);
  };
  const handleDeleteMember = () => {
    setLoading(true);
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/delete-member-data", {
        memberDeleteId,
      })
      .then((res) => {
        if (res.data.responseData) {
          setLoading(false);
          setModalVisible(false);
          setMembersData(res.data.responseData);
          setContentLoaded(true);
          setSuccPopUp("Member has been deleted successfully.");
          setMembDel(true);
        }
      })
      .catch((error) => {
        console.error(error);
        if (
          error.response.data.responseCode === 400 ||
          error.response.data.responseCode === 401
        ) {
          props.checkLoggedIn(false);
        }
      });
  };

  const copyToClipboard = (item, patient_code) => {
    var link = window.location.origin + "/register-practice/" + patient_code;

    const data = [...membersData];
    data[item].modalOpened = false;
    setMembersData(data);

    setMembCopy(true);
    setSuccPopUp("Invitation link has been copied.");
    setModalVisible(false);
    navigator.clipboard.writeText(link);
  };

  const memberResendInvitation = (item) => {
    setLoading(true);
    setErrorPopUp("");
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_programs/resend-invitation", {
        memberId: item.memberId,
      })
      .then((res) => {
        if (res.data.responseData) {
          closeDotModal();
          setSuccPopUp("Invitation has been sent successfully!");
          setLoading(false);
          setContentLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
        if (
          error.response.data.responseCode === 400 ||
          error.response.data.responseCode === 401
        ) {
          setErrorPopUp(error.response.data.errorData);
          setSuccPopUp(false);
          setLoading(false);
          setContentLoaded(true);
          closeDotModal();
        }
      });
  };

  const copyToClipboardPopUP = (patient_code) => {
    var link = window.location.origin + "/register-practice/" + patient_code;

    const data = [...membersData];
    setMembersData(data);

    setMembCopy(true);
    setSuccPopUp("Invitation link has been copied.");
    localStorage.removeItem("lastPatCode");
    setModalVisible(false);
    navigator.clipboard.writeText(link);
  };

  const handleAddTherapistListFirst = () => {
    setErrorPopUp(
      "Your company has to have at least one registered Therapist before you can add Members."
    );
  };

  const handleModal = () => {
    var keepToken = JSON.parse(localStorage.getItem("userData")).token;
    var tokenExpire = JSON.parse(localStorage.getItem("userData")).tokenExpire;

    axios.defaults.headers.common["Authorization"] = keepToken;
    axios
      .post(window.ajaxLink + "cloud_therapist/updateAdminNewStatus", {})
      .then((res) => {
        if (res.data.responseCode === 200) {
          res.data.responseData.userData.token = keepToken;
          res.data.responseData.userData.tokenExpire = tokenExpire;
          localStorage.setItem(
            "userData",
            JSON.stringify(res.data.responseData.userData)
          );
          setIsNewUser(false);
        }
      })
      .catch((error) => {
        console.error(error);
        if (
          error.response.data.responseCode === 400 ||
          error.response.data.responseCode === 401
        ) {
          props.checkLoggedIn(false);
        }
      });
  };
  return (
    <div>
      <Menu title={"Settings"} />
      <div className="programs_dash_hold">
        <div style={{ flexWrap: "wrap" }} className="programs_dash_top_hold">
          <div
            className="programs_dash_top_options"
            style={
              innerWidth < 686
                ? {
                    display: "flex",
                    gap: "10px",
                    fontSize: "1rem",
                    // flexDirection: "column",
                    // alignItems: "center",
                    justifyContent: 'center',
                    flexWrap: 'wrap'
                  }
                : {}
            }
          >
            <div className="programs_dash_contain_opts">
              <div
                className={
                  "programs_dash_option" +
                  (selectedTab === "Profile" ? " p_d_option_selected" : "")
                }
                style={innerWidth > 686 ? { marginRight: "36px" } : {}}
                onClick={() => handleSelectedTab("Profile")}
              >
                My Profile
              </div>
            </div>
            {isCompanyAdmin || isSuperAdmin ? (
              <div className="programs_dash_contain_opts">
                <div
                  className={
                    "programs_dash_option" +
                    (selectedTab === "Members" ? " p_d_option_selected" : "")
                  }
                  style={innerWidth > 686 ? { marginRight: "36px" } : {}}
                  onClick={() => handleSelectedTab("Members")}
                >
                  Members
                </div>
              </div>
            ) : (
              ""
            )}

            {(isCompanyAdmin && isPTCompany) || isSuperAdmin ? (
              <div className="programs_dash_contain_opts">
                <div
                  className={
                    "programs_dash_option" +
                    (selectedTab === "Therapists" ? " p_d_option_selected" : "")
                  }
                  style={innerWidth > 686 ? { marginRight: "36px" } : {}}
                  onClick={() => handleSelectedTab("Therapists")}
                >
                  Therapists
                </div>
              </div>
            ) : (
              ""
            )}

            {isSuperAdmin ? (
              <div className="programs_dash_contain_opts">
                <div
                  className={
                    "programs_dash_option" +
                    (selectedTab === "Admin" ? " p_d_option_selected" : "")
                  }
                  onClick={() => handleSelectedTab("Admin")}
                >
                  Admin Setting
                </div>
              </div>
            ) : (
              ""
            )}

            {isCompanyAdmin || isSuperAdmin ? (
              <div
                className={
                  "p_d_selected_slide" +
                  (selectedTab === "Members"
                    ? " slide_opt_2"
                    : selectedTab === "Therapists"
                    ? " slide_opt_pt"
                    : // : selectedTab === "Rewards" && isCompanyAdmin ? " slide_opt_3"
                    selectedTab === "Admin"
                    //  && !isCompanyAdmin
                    ? " slide_opt_4"
                    : "")
                }
                style={innerWidth < 686 ? { display: "none" } : {}}
              ></div>
            ) : (
              ""
            )}
          </div>
          {selectedTab === "Members" ? (
            hasCompanyTherapists || !isPTCompany ? (
              <div
                className={
                  "programs_new_btn" +
                  (isSuperAdmin || (isCompanyAdmin && hasCompany)
                    ? ""
                    : " prog_edit_invert_disabled")
                }
                onClick={() =>
                  isSuperAdmin || (isCompanyAdmin && hasCompany)
                    ? navigate("/add-new-member")
                    : ""
                }
              >
                Add Member
              </div>
            ) : (
              <div
                className={
                  "programs_new_btn" +
                  (isSuperAdmin || (isCompanyAdmin && hasCompany)
                    ? ""
                    : " prog_edit_invert_disabled")
                }
                onClick={handleAddTherapistListFirst}
              >
                Add Member
              </div>
            )
          ) : selectedTab === "Therapists" ? (
            <div
              className={
                "programs_new_btn" +
                (isSuperAdmin || (isCompanyAdmin && hasCompany)
                  ? ""
                  : " prog_edit_invert_disabled")
              }
              onClick={() =>
                isSuperAdmin || (isCompanyAdmin && hasCompany)
                  ? navigate("/add-new-therapist")
                  : ""
              }
            >
              Add Therapist
            </div>
          ) : (
            ""
          )}
          {selectedTab === "Members" && succPopUp && (
            <div className="prog_err_hold prog_pop_pat_correct">
              <div className="prog_pop_icon_correct prog_err_icon"></div>
              <div className="prog_err_text prog_pop_text_correct">
                {localStorage.getItem("fromEditMember") === null ? (
                  <>
                    <div style={{}}>
                      Member has been created.
                      <div
                        onClick={() =>
                          copyToClipboardPopUP(
                            localStorage.getItem("lastPatCode")
                          )
                        }
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          fontWeight: "bold",
                          display: "inline-block",
                          marginLeft: "5px",
                        }}
                      >
                        Copy Link
                      </div>
                    </div>
                  </>
                ) : succPopUp === "Invitation has been sent successfully!" ? (
                  "Invitation has been sent successfully!"
                ) : (
                  "Member has been updated."
                )}
              </div>
            </div>
          )}
          {selectedTab === "Therapists" && isEmailSent && succPopUp && (
            <div className="prog_err_hold prog_pop_pat_correct">
              <div className="prog_pop_icon_correct prog_err_icon"></div>
              <div className="prog_err_text prog_pop_text_correct">
                {succPopUp}
              </div>
            </div>
          )}
          {selectedTab === "Therapists" && succPopUp && isTherapistCreated && (
            <div className="prog_err_hold prog_pop_pat_correct">
              <div className="prog_pop_icon_correct prog_err_icon"></div>
              <div className="prog_err_text prog_pop_text_correct">
                {succPopUp}
              </div>
            </div>
          )}
          {selectedTab === "Members" && succPopUp && (membDel || membCopy) && (
            <div className="prog_err_hold prog_pop_pat_correct">
              <div className="prog_pop_icon_correct prog_err_icon"></div>
              <div className="prog_err_text prog_pop_text_correct">
                {succPopUp}
              </div>
            </div>
          )}
        </div>
        {selectedTab === "Profile" ? (
        <div className="table_component_container">
          <MyProfile />
          </div>
        ) : selectedTab === "Members" ? (
          
        <div className="table_component_container">
          <CompanyMembersList
            membersData={membersData}
            search={searchMembers}
            updateSearchQuery={updateSearchQuery}
            handleSorting={handleSorting}
            contentLoaded={contentLoaded}
            selectedTab={selectedTab}
            loading={loading}
            modalOpened={handleModalDots}
            handleDeleteModal={handleDeleteModal}
            closeDeleteModal={closeDeleteModal}
            modalVisible={modalVisible}
            handleDeleteMember={handleDeleteMember}
            copyToClipboard={copyToClipboard}
            closeDotModal={closeDotModal}
            updateMemberData={updateMemberData}
            memberResendInvitation={memberResendInvitation}
          />
          </div>
        ) : selectedTab === "Therapists" ? (
          
        <div className="table_component_container">
          <CompanyTherapistsList
            membersData={therapistTabData}
            selectedTab={selectedTab}
            loading={loading}
            search={searchTherapists}
            contentLoadedTherapist={contentLoadedTherapist}
            updateSearchQuery={updateSearchQuery}
            handleSorting={handleTherapistSorting}
            modalOpened={handleTherapistModal}
            closeResendModal={closeResendModal}
            handleResendModal={handleResendModal}
            modalVisible={modalVisible}
            handleResendInvitation={handleResendInvitation}
            updateMemberData={updateTherapistData}
          />
          </div>
        ) : selectedTab === "Admin" ? (
          <AdminTab isSuperAdmin={isSuperAdmin} />
        ) : (
          ""
        )}
      </div>
      {isNewUser && (
        <div className="dlt_wrapper company-admin-modal">
          <div className="dbl_place_on_page">
            <div className="dlt_surround ">
              <div className="welcome-image"></div>
              <div className="dlt_title">
                Welcome <span>{adminName}</span>!
              </div>
              <div className="dlt_description">
                You can now manage members for your organization on Virdio
                Health
              </div>
              <div className="dlt_exit_btm">
                <div
                  className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn"
                  onClick={handleModal}
                >
                  Get Started
                </div>
              </div>
            </div>
          </div>
          <div
            className="approval_close tsk_info_cls"
            onClick={handleModal}
          ></div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text">{errorPopUp}</div>
        </div>
      )}
    </div>
  );
};

export default SettingsDash;
